import { Rotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/entities/Rotationsplan';
import { DeleteRotationsplanDesktop } from '@/domain/mitarbeiter/features/rotationsplan/features/DeleteRotationsplan/DeleteRotationsplanDesktop';
import { DeleteRotationsplanMobile } from '@/domain/mitarbeiter/features/rotationsplan/features/DeleteRotationsplan/DeleteRotationsplanMobile';
import { ExportRotationsplanDesktop } from '@/domain/mitarbeiter/features/rotationsplan/features/ExportRotationsplan/ExportRotationsplanDesktop';
import { ExportRotationsplanMobile } from '@/domain/mitarbeiter/features/rotationsplan/features/ExportRotationsplan/ExportRotationsplanMobile';
import {
  Button,
  Drawer,
  DrawerContent,
  DrawerTrigger,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@e2n/ui';
import { faEllipsisVertical } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function ActionDropdownMenu({
  rotationsplan,
}: {
  rotationsplan: Rotationsplan;
}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <Button variant="icon">
          <FontAwesomeIcon icon={faEllipsisVertical} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="min-w-32" align="end">
        <ExportRotationsplanDesktop
          rotationsplan={rotationsplan}
          onClose={() => setIsOpen(false)}
        />
        <DeleteRotationsplanDesktop
          rotationsplanId={rotationsplan.id}
          onClose={() => setIsOpen(false)}
        />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export function ActionDrawer({
  rotationsplan,
}: {
  rotationsplan: Rotationsplan;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [view, setView] = useState<'delete' | undefined>();
  const { t } = useTranslation();

  return (
    <Drawer
      open={isOpen}
      onOpenChange={(open) => {
        setView(undefined);
        setIsOpen(open);
      }}>
      <DrawerTrigger asChild>
        <Button variant="icon">
          <FontAwesomeIcon icon={faEllipsisVertical} />
        </Button>
      </DrawerTrigger>
      <DrawerContent className="flex flex-col items-start gap-5 p-4 w-full text-sm">
        {view === undefined && (
          <>
            <ExportRotationsplanMobile
              rotationsplan={rotationsplan}
              onClose={() => setIsOpen(false)}
            />
            <Button
              onClick={() => setView('delete')}
              className="font-normal hover:bg-transparent"
              variant="ghost-destructive">
              {t(
                'domain.mitarbeiter.rotationsplan.rotationsplaene.deleteRotationsplan.label',
              )}
            </Button>
          </>
        )}
        {view === 'delete' && (
          <DeleteRotationsplanMobile
            rotationsplanId={rotationsplan.id}
            handleClose={() => {
              setIsOpen(false);
            }}
          />
        )}
      </DrawerContent>
    </Drawer>
  );
}
